// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.G747ub{font-family:"Helvetica Neue","ruble",Helvetica,Arial,sans-serif;position:absolute;left:0;right:0;bottom:30px;font-size:14px;display:flex;width:100%;justify-content:center;opacity:0;transition:opacity 0.3s ease;color:#ffffff}@media (max-width: 599px){.G747ub{bottom:15px;font-size:12px}}.Txrvtt{opacity:1}.IzQ2Wu{height:12px;width:15px}.IzQ2Wu.axV9Jw{margin-right:7px}.IzQ2Wu.yks66F{margin-left:7px}@media (max-width: 599px){.IzQ2Wu{height:10px;width:12px}}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link-container": `G747ub`,
	"linkContainer": `G747ub`,
	"link-fade-in": `Txrvtt`,
	"linkFadeIn": `Txrvtt`,
	"icon": `IzQ2Wu`,
	"ltr": `axV9Jw`,
	"rtl": `yks66F`
};
export default ___CSS_LOADER_EXPORT___;
